import axios from "axios";
import apiConfig from "../apiConfig.json";
import serverConfig from "../serverConfig.json";

const IsLogin = async () => {
  const tokenLocal = localStorage.getItem("token");
  const headers = {
    Authorization: "Bearer " + tokenLocal,
  };

  if (tokenLocal) {
    try {
      const response = await axios.post(
        serverConfig.server.url + apiConfig.api.authControllers.isLogin,
        {},
        { headers }
      );

      if (response.data) {
        if (response.data.code == 200) {
          localStorage.setItem("FullName", response.data.data.first_name + " " + response.data.data.last_name);
          localStorage.setItem('credentials', JSON.stringify(response.data.data))
          return response.data.data.user_roles;
        } else {
          // localStorage.clear();
          localStorage.getItem("FullName") &&
            localStorage.removeItem("FullName");
          localStorage.getItem("mobile") && localStorage.removeItem("mobile");
          localStorage.getItem("token") && localStorage.removeItem("token");

          return false;
        }
      } else {
        return "error api";
      }
    } catch (error) {
      console.error("Error making API call:", error);
      return "error api call";
    }
  } else {
    return "error no auth value";
  }
};

export default IsLogin;
